/*
 * iForte's logo as the organiser supplied it (yellow on its black plate),
 * converted to WebP. Used whenever `GET /v1/brand` has no organiser logo yet
 * or it fails to load; never redrawn in code.
 */
import iforteLogo from "./iforte-logo.webp";

export const IFORTE_LOGO = iforteLogo;
